import ApiService from '@/services/api.service';
import getters from '@/store/global';

const state = {
    albums: [],
    count: '',
    next: '',
    details: {},
    newAlbum: {},
    errors: {}
};

getters['fetchPhotoAlbums'] = function(state) {
    return state.albums;
}
getters['fetchNewPhotoAlbum'] = function(state) {
    return state.newAlbum;
}
getters['fetchNextPhotoAlbums'] = function(state) {
    return state.next;
}
getters['fetchPhotoAlbumById'] = (state) => (id) => {
    if (state.albums) {
        return state.albums.find(album => album.id === id)
    }
    return {}
}
getters['fetchPhotoDetails'] = function(state) {
    return state.details;
}
getters['fetchPhotoAlbumsCount'] = function(state) {
    return state.count;
}

const actions = {
    get(context, payload) {
        return ApiService
            .get('profile/' + payload + '/albums/')
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_ALBUMS', response.data.results);
                context.commit('SET_COUNT', response.data.count);
                context.commit('SET_NEXT', response.data);
            })
            .catch((response) => {
                if (response.status == 400) {
                    context.commit('SET_ALBUMS', []);
                    context.commit('SET_ERROR', response.data);
                    throw new Error('Something goes wrong');
                }
            });
    },
    getMy(context) {
        return ApiService
            .get('albums/')
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_ALBUMS', response.data.results);
                context.commit('SET_COUNT', response.data.count);
                context.commit('SET_NEXT', response.data);
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            });
    },
    getNext(context) {
        return ApiService
            .get(context.state.next)
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('ADD_ALBUMS', response.data.results);
                context.commit('SET_NEXT', response.data);
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            });
    },
    getDetails(context, payload) {
        return ApiService
            .get('albums/' + payload + '/detail')
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_DETAILS', response.data);
            })
            .catch((response) => {
                if (response.status == 400) {
                    context.commit('SET_DETAILS', {});
                    context.commit('SET_ERROR', response.data);
                    throw new Error('Something goes wrong');
                }
            });
    },
    create(context, payload) {
        return ApiService
            .post('albums/create/', payload)
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_NEW', response.data);
                context.commit('ADD_ALBUM', response.data);
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            });
    },
    delete(context, payload) {
        return ApiService
            .delete('albums/' + payload + '/remove/')
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_ALBUMS', response.data)
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            });
    },
    update(context, payload) {
        return ApiService
            .patch('albums/' + payload.id + '/update/', payload.data)
            .then((response) => {
                context.commit('SET_ERROR', {});
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            });
    },
    setEmptyNew(context, payload) {
        context.commit('SET_NEW', {});
    }
};

const mutations = {
    SET_ALBUMS(state, albums) {
        state.albums = albums;
        state.errors = {};
    },
    ADD_ALBUMS(state, albums) {
        state.albums = state.albums.concat(albums);
        state.errors = {};
    },
    ADD_ALBUM(state, album) {
        state.albums.push(album);
        state.errors = {};
    },
    SET_COUNT(state, count) {
        state.count = count;
        state.errors = {};
    },
    SET_NEXT(state, data) {
        if (data.page < data.num_pages) {
            state.next =
                data.url +
                '?' +
                data.page_param +
                '=' +
                (data.page + 1);
        } else {
            state.next = '';
        }
        state.errors = {};
    },
    SET_NEW(state, newAlbum) {
        state.newAlbum = newAlbum;
        state.errors = {};
    },
    SET_DETAILS(state, details) {
        state.details = details;
        state.errors = {};
    },
    SET_ERROR(state, errors) {
        state.errors = errors;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
